import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'defaultValue',
    standalone: false
})
export class DefaultValuePipe implements PipeTransform {
  transform(value: any, defaultValue: string = '-'): string {
    return value === null || value === undefined || value === '' ? defaultValue : value;
  }
}
